import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {OperatingUnit} from 'src/app/operating-units/shared/model/operating-unit.model';

@Injectable()
export class ActiveOperatingUnitsResolver implements Resolve<Observable<OperatingUnit[]>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(): Observable<OperatingUnit[]> {

    return this.facadeService.getAllActiveOperatingUnits().pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
